import Container from '@brands/Components/Container/Container';
import { useWindowSize } from '@brands/hooks';
import { parsePhoneNumber } from 'libphonenumber-js';
import React, { useEffect, useRef, useState } from 'react';

import styles from './styles.module.scss';
import CareHistory from './Sections/CareHistory';
import UpcomingAppointments from './Sections/UpcomingAppointments';
import ProfileCommonHeader from '../MyProfile/ProfileCommonHeader/ProfileCommonHeader';

export const isValidPhoneNumberFormat = (phoneNumber: string): boolean => {
  const phoneNumberPattern = /^\+?1?[-.\s]?\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;

  return phoneNumberPattern.test(phoneNumber);
};

export const displayPhoneNumber = (pharmacyPhoneNumber: string): string => {
  const phoneNumber = parsePhoneNumber(pharmacyPhoneNumber, 'US');
  if (phoneNumber) {
    return phoneNumber.formatNational();
  }
  return '';
};

const MyCare = (): JSX.Element => {
  const screenSize = useWindowSize();
  const [currentTab, setCurrentTab] = useState('upcoming_appointments');
  const containerRef = useRef<HTMLDivElement>(null);

  const myCareTabs = [
    { label: 'Upcoming Appointments', value: 'upcoming_appointments' },
    { label: 'Care History', value: 'care_history' },
  ];

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setCurrentTab(hash);
    }
  }, [window.location.hash]);

  return (
    <Container
      patientDashboard
      childClassName={styles.dashboard}
      containerStyle={{
        justifyContent: screenSize.width >= 1289 ? 'center' : 'start',
        overflowY: screenSize.width >= 1289 ? 'hidden' : 'scroll',
      }}
    >
      <div className={styles.MyCareContainer} ref={containerRef}>
        <ProfileCommonHeader currentTab={currentTab} setCurrentTab={setCurrentTab} tabs={myCareTabs} />

        {currentTab === 'upcoming_appointments' && <UpcomingAppointments />}
        {currentTab === 'care_history' && <CareHistory />}
      </div>
    </Container>
  );
};

MyCare.defaultProps = {
  reviewProfile: false,
};

export default MyCare;
